import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getSwapEmployeesV2 } from "../../../../redux/features/schedule/ScheduleApi";
import { setFilterStartDate, setFilterEndDate } from "../../../../redux/features/schedule/ScheduleSlice";
import { IUser } from "../../../../redux/features/user/models/user";
import { useAppDispatch, RootState } from "../../../../redux/store";
import { DateTimeUtil } from "../../../../utils";
import { ScheduleV2 } from "../../../../types";

interface Props {
  onContinue: () => void;
  setNote: (text: string) => void;
}

const TradeShiftInitialStep: React.FC<Props> = ({ onContinue, setNote }) => {
  const selectedShift = useSelector((state: RootState) => state.schedule.selectedScheduleForCannotWork) as ScheduleV2;
  const dispatch = useAppDispatch();
  const User = useSelector((state: any) => state.user.user) as IUser;
  const actionConsecutiveDays = useSelector((state: RootState) => state.schedule.actionConsecutiveDays);
  const getEffectiveActionConsecutiveDays = actionConsecutiveDays > 1 ? actionConsecutiveDays - 1 : undefined;

  useEffect(() => {
    const startDate = DateTimeUtil.ParseWithDayjsUtc(selectedShift.start_time!);
    const endDate = new Date(selectedShift.end_time!);
    endDate.setDate(endDate.getDate() + 7);
    dispatch(setFilterStartDate(startDate.toISOString()));
    dispatch(setFilterEndDate(endDate.toISOString()));

    const payload = {
      request_type: 1,
      start_date: startDate.toISOString(),
      end_date: endDate.toISOString(),
      assigned_shift_code: selectedShift.shift?.shift_code || "",
      department_code: User.departmentCode || "",
      assigned_department_code: User.departmentCode || "",
      group_code: [],
      name_search: "",
      days_in_swapping_block: actionConsecutiveDays,
    };

    dispatch(getSwapEmployeesV2(payload));
  }, []);

  return (
    <div className="mt-2 bg-white p-4 rounded shadow">
      <div className="border p-3 bg-gray-100 mb-3 rounded">
        <p className="text-sm text-gray-800">
          {DateTimeUtil.formatDateTimeRangeUtc(
            selectedShift.start_time!,
            selectedShift.end_time!
          )}
          {getEffectiveActionConsecutiveDays ? ` + ${getEffectiveActionConsecutiveDays} days` : ""}
        </p>
        <p className="text-sm text-gray-600">
          {selectedShift.emp_details?.emp_name}
        </p>
      </div>

      <p className="text-sm mb-1">1. Submit a Swap Request – Select the shift you want to trade and choose available shifts from other employees. A reason for the request may be required based on company policy.</p>
      <p className="text-sm mb-1">2. Approval Process – Your request will go through an approval workflow, which may include managers, supervisors, or other designated approvers, depending on company settings.</p>
      <p className="text-sm mb-3">3. Final Confirmation – Once all required approvals are completed, the shift trade will be finalized, and both employees will receive confirmation.</p>

      <textarea
        className="w-full p-2 border rounded text-sm"
        placeholder="Reason for request"
        rows={3}
        onChange={(e) => setNote(e.target.value)}
      />

      <div className="text-right mt-4">
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded text-sm"
          onClick={onContinue}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default TradeShiftInitialStep;
